import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Transaction } from '../models/transaction';
import { Observable, of } from 'rxjs';
import { GlobalAppData } from '../models/global-app-data';
import { getQueryParamByName } from '../common/utils';
import { environment } from '../../environments/environment';
import { delay, tap, flatMap } from 'rxjs/operators';
import { LoadingService } from './loading.service';
import {TransactionStatus} from '../models/transaction-status';


@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(private http: HttpClient,
              private gd: GlobalAppData,
              private loadingService: LoadingService) { }
   httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  getOrder(orderId?: string): Observable<Transaction> {
    if (!orderId) {
      orderId = getQueryParamByName('t');
    }
    this.gd.transId = orderId;
    const url = environment.PAYMENT_UI + '/epms/order/' + orderId;
    return this.http.get<Transaction>(url, 
      { ...this.httpOptions, withCredentials: true }  // ← ADD
    );
  }

  fetchPgResponse(): Observable<string> {
    const orderId = this.gd.transId;
    const url = environment.PAYMENT_UI + '/epms/order/final/' + orderId;
    return of(url).pipe(
      tap((data) => this.loadingService.setLoading(true, data)),
      delay(2000), 
      flatMap(data => this.http.get<string>(url,
        { ...this.httpOptions, withCredentials: true }  // ← ADD
      ))
    );
  }

  updateTransactionStatus(transactionStatus: TransactionStatus): Observable<string> {
    const url = environment.PAYMENT_UI + '/epms/updateTxStatus';
    return this.http.post<string>(url, transactionStatus, 
      { ...this.httpOptions, withCredentials: true }  // ← ADD
    );
  }

  sendTxRejectStatus(transactionId:string): Promise<void> {
    const orderTx = this.gd.orderTransaction;
    orderTx.orderTransactionId = transactionId != null ? transactionId : orderTx.orderTransactionId
    const transactionStatus = new TransactionStatus();
    transactionStatus.orderTransactionId = orderTx.orderTransactionId;
    transactionStatus.pgmResponseCode = '203';
    transactionStatus.pgmResponseMessage = 'The transaction has been cancelled by the user.';
    return new Promise<void>((resolve) => {
    this.updateTransactionStatus(transactionStatus).subscribe({
        next: (data) => {
          console.log('tx reject status updated successfully');
          resolve();
        },
        error: (error) => {
          console.log('error while updating the tx status');
          resolve(); // resolve on error too so handlePaypalDecline always fires
        }
      });
    });
  }

  getContextBody(ctx: string): Observable<{ sessionId: string; transactionId: string }> {
    const url = environment.PAYMENT_UI + '/epms/getContextBody';
    return this.http.post<{ sessionId: string; transactionId: string }>(
      url,
      { ctx },
      { ...this.httpOptions, withCredentials: true }
    );
  }

  resumePayment(ctx: string): Observable<{ sessionId: string; transactionId: string }> {
    const url = environment.PAYMENT_UI + '/epms/resumePayment';
    return this.http.post<{ sessionId: string; transactionId: string }>(
      url,
      { ctx },
      { ...this.httpOptions, withCredentials: true }
    );
  }

}
